/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import { Bind } from 'lodash-decorators';
import { observer } from 'mobx-react';
import root from 'window-or-global';
import DebugOptionsService from 'services/DebugOptions.service';
import DebugBarWrapper from './DebugBarWrapper';
import DebugButton from './DebugButton';
import DebugOptions from './DebugOptions';
import DebugOption from './DebugOption';

@observer
class DebugBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
    };
    this.debugOptionsRef = React.createRef();
  }

  @Bind
  onDebugButtonClick() {
    const { hidden } = this.state;
    this.setState({ hidden: !hidden });
  }

  @Bind
  setDebugOption(option, forcePageReload) {
    DebugOptionsService.setDebugOptionValueByName(option.name, option.value);
    this.forceUpdate();
    if (forcePageReload) {
      root.location.reload();
    }
  }

  render() {
    const { hidden } = this.state;
    return (
      <DebugBarWrapper>
        <DebugOptions innerRef={this.debugOptionsRef} hidden={hidden}>
          {DebugOptionsService.getDebugOptionsModel().map(option => (
            <DebugOption
              key={option.name}
              optionName={option.name}
              values={option.values}
              checked={DebugOptionsService.getOptionValueByName(option.name)}
              onValueChange={optionData => this.setDebugOption(optionData, option.reloadOnChange)}
            />
          ))}
        </DebugOptions>
        <DebugButton onClick={this.onDebugButtonClick}>
          {hidden ? 'Show debug' : 'Hide debug'}
        </DebugButton>
      </DebugBarWrapper>
    );
  }
}

export default DebugBar;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/DebugBar/index.jsx